import { TopNav, PageShell, BackCoverFooter, BrutalistBadge } from "@/app/components/brand-scaffold";
import { siteHeaderActionsEn, siteNavItemsEn } from "@/app/content-en";

export default function EnglishTrustSettlementPage() {
  return (
    <PageShell>
      <TopNav navItems={siteNavItemsEn} actionItems={siteHeaderActionsEn} homeHref="/en" />
      <main className="relative z-10 w-full overflow-hidden px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="mx-auto max-w-4xl">
          <div className="mb-8">
            <BrutalistBadge bgClass="bg-[#A3E635]" hoverBgClass="hover:bg-black" hoverTextClass="hover:text-white">
              TRUST & SETTLEMENT
            </BrutalistBadge>
          </div>
          <h1 className="text-4xl sm:text-5xl font-black text-black mb-4">
            Trust & Settlement
          </h1>
          <p className="text-lg font-bold text-zinc-600 mb-12">
            How calls are metered, audited, and protected.
          </p>

          <div className="space-y-12">
            <section>
              <h2 className="text-2xl font-black text-black mb-4 border-b-4 border-black pb-2">Current Status</h2>
              <div className="border-4 border-black bg-[#FACC15]/20 p-6 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
                <ul className="space-y-3 text-sm">
                  <li className="flex items-start gap-2"><span className="font-black text-black">•</span> All calls are free during Preview. Call Credits are for internal metering only.</li>
                  <li className="flex items-start gap-2"><span className="font-black text-black">•</span> Call Credits are not fiat balance. No withdrawal capability exists today.</li>
                  <li className="flex items-start gap-2"><span className="font-black text-black">•</span> All call records are auditable. result_package contains full execution metadata.</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-black text-black mb-4 border-b-4 border-black pb-2">How Both Parties Are Protected</h2>
              <div className="grid gap-4 sm:grid-cols-2">
                <div className="border-4 border-black bg-white/85 p-5 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
                  <h3 className="font-black mb-2">Caller Side</h3>
                  <ul className="space-y-2 text-sm text-zinc-700">
                    <li>• Full contract inspection before calling</li>
                    <li>• result_package includes output, duration, status</li>
                    <li>• Standardized error codes for failed calls</li>
                    <li>• Local supervisor logs all call history</li>
                  </ul>
                </div>
                <div className="border-4 border-black bg-white/85 p-5 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
                  <h3 className="font-black mb-2">Responder Side</h3>
                  <ul className="space-y-2 text-sm text-zinc-700">
                    <li>• Core implementation never leaves local boundary</li>
                    <li>• Protocol-layer token verifies caller identity</li>
                    <li>• Versioned contracts protect backward compatibility</li>
                    <li>• Call volume and patterns monitored locally</li>
                  </ul>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-black text-black mb-4 border-b-4 border-black pb-2">How result_package Supports Metering</h2>
              <div className="border-4 border-black bg-white/85 p-6 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
                <p className="text-sm text-zinc-700 mb-4">Every call returns a result_package containing:</p>
                <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
                  {resultPackageFieldsEn.map((f) => (
                    <div key={f.field} className="border-2 border-black/20 p-3">
                      <code className="text-xs font-mono font-bold">{f.field}</code>
                      <p className="text-xs text-zinc-600 mt-1">{f.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-black text-black mb-4 border-b-4 border-black pb-2">Commercialization Principles</h2>
              <div className="border-4 border-black bg-[#A3E635]/10 p-6 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
                <ul className="space-y-4 text-sm text-zinc-800">
                  <li className="flex items-start gap-3">
                    <span className="font-black text-[#A3E635] text-lg">1</span>
                    <span>Commercialization will be announced after stable supply-demand emerges on Marketplace.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="font-black text-[#A3E635] text-lg">2</span>
                    <span>No commission rates are promised during Preview. No fiat withdrawal is available.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="font-black text-[#A3E635] text-lg">3</span>
                    <span>Protocol-layer metering fields are ready. No Responder code changes needed when commercialization starts.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="font-black text-[#A3E635] text-lg">4</span>
                    <span>Local Mode and Self-host deployments are always free. Not affected by commercialization.</span>
                  </li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-black text-black mb-4 border-b-4 border-black pb-2">Future Pricing</h2>
              <p className="text-sm text-zinc-600">
                Pricing structure will be announced separately after real active supply-demand emerges on Marketplace. Current focus is making the protocol and local runtime stable and usable.
              </p>
            </section>
          </div>
        </div>
      </main>
      <BackCoverFooter />
    </PageShell>
  );
}

const resultPackageFieldsEn = [
  { field: "status", desc: "Success / failure / timeout" },
  { field: "duration_ms", desc: "Execution time" },
  { field: "output", desc: "Structured output" },
  { field: "cost_tokens", desc: "Tokens consumed" },
  { field: "version", desc: "Hotline version" },
  { field: "timestamp", desc: "Call timestamp" },
];
